import { Component } from '@angular/core';

@Component({
  selector: 'app-callme',
  templateUrl: './callme.component.html',
  styleUrls: ['./callme.component.css']
})
export class CallmeComponent {

}
